import axios from "axios";

export const state = {
    creditreports: [],
};

export const getters = {
    creditreports: (state) => state.creditreports,
};

export const mutations = {
    setCreditReports(state, newValue) {
        state.creditreports = newValue;
    },
};

export const actions = {
    async fetchCreditReports({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/credit-score-reports/${fyear}`).then((res) => {
            commit("setCreditReports", res.data.creditreports);
        });
    },
};
